import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_container_types_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, Description?: string, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, DimensionUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_grid/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, Description?: string, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, DimensionUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, Description?: string, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, DimensionUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
